// src/services/profiles/profileMigrationApi.ts

import baseApi from "../../lib/baseApi";
import type {
  ProfileMigrationStatusResponse,
  CurrentProfileResponse,
  MigrationHistoryResponse,
  MigrateProfilePayload,
  MigrateProfileResponse,
} from "../../types/profiles/profileMigrationTypes";

export const fetchProfileMigrationStatusApi =
  async (): Promise<ProfileMigrationStatusResponse> => {
    const response = await baseApi.get("/profiles/migrate/status/");
    return response.data;
  };

export const fetchCurrentProfileApi =
  async (): Promise<CurrentProfileResponse> => {
    const response = await baseApi.get("/profiles/migrate/current-profile/");
    return response.data;
  };

export const fetchProfileMigrationHistoryApi =
  async (): Promise<MigrationHistoryResponse> => {
    const response = await baseApi.get("/profiles/migrate/history/");
    return response.data;
  };

export const migrateProfileApi =
  async (payload: MigrateProfilePayload): Promise<MigrateProfileResponse> => {
    const response = await baseApi.post("/profiles/migrate/migrate-profile/", payload);
    return response.data;
  };